/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2020 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import loadable from '@loadable/component';

export const namespace = 'canalplus.block.apash.reactivation_before_end';
export const Component = loadable(
  () => import('./container/ReactivationBeforeEndContainer')
);
export { default as propsFormatter } from './propsFormatter';
